import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-shares text-[#65676B] mr-3" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-[#65676B]" }, "Share", -1)
const _hoisted_3 = { class: "px-1 py-1" }

import { useNewsFeedStore } from "@/store/newsfeed"
  import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useRouter } from "vue-router"
  import { toastController } from "@ionic/vue"

  interface PostMeta {
    url: string
    title: string
    description: string
    og: {
      image: string
    }
  }

  interface Props {
    postId: string
    postMeta: PostMeta
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'shareButton',
  props: {
    postId: null,
    postMeta: null
  },
  emits: ["addShare"],
  setup(__props: any, { emit }) {

const props = __props as {
    postId: string
    postMeta: PostMeta
  }

  const newsfeedStore = useNewsFeedStore()
  const authenticationStore = useAuthenticationStore()

  const socials = ["facebook", "LinkedIn", "Twitter"]

  
  

  /**
   * Checks if a user is logged in
   */
  const checkForAuth = () => {
    if (!authenticationStore.token) {
      useRouter().push("/login")
    }
    return true
  }

  /**
   * Activates the api to share the post to workbean world via the current user account
   */
  const shareToWorld = (external?: boolean) => {
    if (checkForAuth()) {
      newsfeedStore.shareFeed(props.postId, external ? 1 : "").then(async (success) => {
        const toast = await toastController.create({
          message: "Post shared to the World successfully.",
          duration: 3000,
          position: "top",
          color: "success",
        })
        await toast.present()
        if (success) emit("addShare", true)
      })
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!

  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "inline-block text-left right-0 absolute bottom-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(MenuButton), { class: "justify-center rounded-md px-10 py-2 font-bold hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-100 ease-out",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-in",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuItems), { class: "right-0 mt-2 w-56 origin-top-right font-bold text-primary-black rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (social, index) => {
                  return _createVNode(_unref(MenuItem), {
                    key: `${index}_social`
                  }, {
                    default: _withCtx(({ active }) => [
                      _createVNode(_component_ShareNetwork, {
                        network: social,
                        url: __props.postMeta.url,
                        media: __props.postMeta.og?.image,
                        title: __props.postMeta.title,
                        description: __props.postMeta.description,
                        hashtags: "workbean,",
                        onOpen: shareToWorld
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["capitalize", [active ? 'bg-violet-500 text-primary-violet' : 'text-primary-black', 'group flex w-full items-center rounded-md px-2 py-2 text-sm']])
                          }, _toDisplayString(social), 3)
                        ]),
                        _: 2
                      }, 1032, ["network", "url", "media", "title", "description"])
                    ]),
                    _: 2
                  }, 1024)
                }), 64)),
                _createVNode(_unref(MenuItem), null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      class: _normalizeClass([active ? 'bg-violet-500 text-primary-violet' : 'text-primary-black', 'group flex w-full items-center rounded-md px-2 py-2 text-sm']),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (shareToWorld()))
                    }, " Workbean World ", 2)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})